export const buildTikTokEmbedUrl = (videoId: string): string =>
  `https://www.tiktok.com/player/v1/${videoId}?music_info=1&description=1&rel=0`;
